<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="toast">
    @for (message of messages; track $index) {
        <div
            class="toast__content flex gap-8 align-items-center"
            [ngClass]="message.type"
            (click)="removeMessage(message)"
        >
            <m-svg [iconName]="getIconName(message)" />
            @if (message?.title) {
                <h3>{{ message.title | translate }}</h3>
            }
            @if (message?.message) {
                <p>{{ message.message | translate }}</p>
            }
        </div>
    }
</div>
